// WebRTC 数据通道协议 — 文件传输元数据优先协议
// 替换 LocalSend 的 nonce/token/cert 握手为简化的协议

import type { DataChannelMessage, FileDto } from '@kuaichuan/shared';

export type { DataChannelMessage, FileDto };

// 解析 incoming 数据通道消息（文本帧）
export function parseDataChannelMessage(text: string): DataChannelMessage | null {
  try {
    return JSON.parse(text) as DataChannelMessage;
  } catch {
    return null;
  }
}

export function stringifyDataChannelMessage(msg: DataChannelMessage): string {
  return JSON.stringify(msg);
}
